import { useCashForMortgageStore } from './useCashForMortgageStore'

export const CashForMortgageStore = {
  useCashForMortgage: useCashForMortgageStore,
}
